module.exports = __webpack_public_path__ + "img/check-mark-white.f8641f70.svg";